'use client';

import ErrorWrapperCommon from './ErrorWrapperCommon';

export default ErrorWrapperCommon;
